import * as mongoose from 'mongoose'
import { ImageClass, SubVertical } from 'common/constants'
import { replaceToHttps } from '@shopping/Img'

export interface Image extends mongoose.Document {
  id?: string
  imageUrl: string
  imageName?: string
  width?: number
  height?: number
  fileSize?: number
  sortOrder?: number
  originalFileName?: string
  representativeImage?: boolean
  imageClassType?: ImageClass
}

export interface AnimationGif extends mongoose.Document {
  videoId?: string
  gifThumbnailUrl?: string
  gifThumbnailWidth?: number
  gifThumbnailHeight?: number
}

export interface RelationProductImage extends mongoose.Document {
  id?: string
  imageUrl: string
  width?: number
  height?: number
  type: ImageClass
  order: number
}

export const getRepresentativeImage = (images: Image[]): Image => {
  const result = images && images.length > 0 && (images.find(image => image.representativeImage === true) || images[0])

  if (result && result.imageUrl) {
    result.imageUrl = replaceToHttps(result.imageUrl)
  }
  return result
}

export const getRelationProductRepresentativeImage = (images: RelationProductImage[]): RelationProductImage => {
  const result = images && images.length > 0 && (images.find(image => image.type === ImageClass.REPRESENT) || images[0])

  if (result && result.imageUrl) {
    result.imageUrl = replaceToHttps(result.imageUrl)
  }
  return result
}
